import React, { Component } from "react";
import List from 'devextreme-react/list';

function ItemTemplate(data) {
    return <div>{data.Name}</div>;
}

export default class PainelIssSimplesNacional extends Component {


    constructor() {
        super();

        this.relatorios = [
            { 
                descricao: "Espelho CPBS",
                path: "/espelho_cpbs_nfse",
                origem: { pathname: "/painel_iss", aba: 0}
            },
            { 
                descricao: "Relatório de Notas", 
                path: "/nfse_cpbs",
                origem: { pathname: "/painel_iss", aba: 0}
            },
            {
                descricao: "Comparativo Declarado x Faturado",
                path: "/relatorio_fat_dec_sn",
                origem: { pathname: "/painel_iss", aba: 0 }
            },
            {
                descricao: "Declarações PGDAS-D",
                path: "/declaracoes_sn",
                origem: { pathname: "/painel_iss", aba: 0 }
            },
        ];

        this.selecionarRelatorio = this.selecionarRelatorio.bind(this);
    }



    selecionarRelatorio(item) {
        const data = item.itemData;
        console.log(data);
        if (data != undefined && data.path != undefined) {
            this.props.history.push({ pathname: data.path, origem: data.origem });
        }
    }



    render() {
        return (
            <div>
                <br />
                <h4>Relatórios</h4>

                <List
                    searchMode={"contains"}
                    searchExpr={"descricao"}
                    itemTemplate={ItemTemplate}
                    dataSource={this.relatorios} height={250}
                    itemRender={item => <div>{item.descricao}</div>}
                    onItemClick={item => this.selecionarRelatorio(item)}
                />
            </div>

        );

    }
}